import {AccountSource} from "../types/AccountSource";
import {Observable, ReplaySubject, Scheduler} from "rxjs";
import {AccountBriefRecord, AccountBriefRecords} from "../types/AccountBriefRecord";
import {isNotNull} from "../../js/util/UtilFunctions";

export class ReadonlyAccountStore implements AccountSource {

    private readonly selectedId$ = new ReplaySubject<number>(1);
    private readonly selected$ = new ReplaySubject<AccountBriefRecord | null>(1);

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    private constructor(private readonly parent: AccountSource) {
        this.init();
    }

    private init() {
        this.watchParent();
        this.watchSelectedId();
    }

    private watchParent() {
        this.parent
            .current
            .takeUntil(this.destroyed$)
            .filter(isNotNull)
            .map((account) => account.id)
            .subscribe((id) => this.selectedId$.next(id));
    }

    private watchSelectedId() {
        Observable.combineLatest(this.selectedId$, this.accounts)
                  .map(([id, accounts]) => this.findAccount(id, accounts))
                  .subscribe((account) => this.selected$.next(account || null));
    }

    private findAccount(id: number, accounts: AccountBriefRecords): AccountBriefRecord | undefined {
        return accounts.find((a) => a.id === id);
    }

    public selectAccount(id: number) {
        this.selectedId$.next(id);
    }

    public get accounts(): Observable<AccountBriefRecords> {
        return this.parent.accounts;
    }

    public get current(): Observable<AccountBriefRecord | null> {
        return this.selected$.observeOn(Scheduler.async);
    }

    public destroy() {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }

    public static create(parent: AccountSource): ReadonlyAccountStore {
        return new ReadonlyAccountStore(parent);
    }
}
